import PressableIcon from '@ui/buttons/PressableIcon'
import GlassButton from '@ui/elements/Glass/GlassButton'
import { router } from 'expo-router'
import { useStagesStore } from 'hooks/useStagesStore'
import { useAnimatedOpacity } from '@ui/animated/useAnimatedOpacity'
import { usePreventBack } from '../usePreventBack'
import { Preset } from '../types'

const backOnPreset: Record<Preset, boolean> = {
  empty: false,
  intro: true,
  deals: true,
  staff: true,
  customer: true,
  main: true,
  avatar: true,
  dev: true,
}

export default function BackButton() {
  const back = useStagesStore((state) => state.back)
  const preset = useStagesStore((state) => state.preset)

  const onPress = () => {
    if (!back) return

    if (typeof back === 'function') {
      back()
      return
    }

    if (router.canGoBack()) {
      router.back()
      return
    }
  }

  usePreventBack({ back: !!back })

  const styleOpacity = useAnimatedOpacity(!!back && backOnPreset[preset])

  return (
    <GlassButton style={styleOpacity}>
      <PressableIcon disabled={!back} name="arrow-left" onPress={onPress} />
    </GlassButton>
  )
}
